import axios from "axios"
import Tools from '@/tools/tools'
import token from '../tools/tokenTools'
import config from '@/configs/appConfig'
import { ElMessage } from 'element-plus'

/**
 * request配置
 */
let axiosConfig = {
    baseURL: config.http
};

/**
 * request请求
 */
const http = axios.create(axiosConfig)

/**
 * 请求拦截器
 */
http.interceptors.request.use((config) => {
    const accessToken = token.get()
    if (accessToken) {
        config.headers.Authorization = Tools.ucFirst(accessToken.token_type) + accessToken.access_token
    }
    return config
}, function (error) {
    return error
})

/**
 * 响应拦截器
 */
let showAuthMsg = false // 防止多个请求同时401时重复弹窗
let showForbiddenMsg = false // 防止多个请求同时403时重复弹窗
http.interceptors.response.use((response) => {
    token.updateExpiresIn()
    return response
}, function (error) {
    // 401统一处理：登录失效或无权限，弹窗提示→清除token→跳转登录页
    if (error.response && error.response.status == 401) {
        if (!showAuthMsg) {
            showAuthMsg = true
            ElMessage({ message: '登录已失效或无权限访问，请重新登录', type: 'warning' })
            setTimeout(() => { showAuthMsg = false }, 2000)
        }
        sessionStorage.removeItem('token')
        window.location.href = window.location.pathname + '#/login'
    }
    // 403统一处理：已登录但无权限操作该数据，仅弹窗提示不跳转
    if (error.response && error.response.status == 403) {
        if (!showForbiddenMsg) {
            showForbiddenMsg = true
            ElMessage({ message: '无权限执行此操作', type: 'warning' })
            setTimeout(() => { showForbiddenMsg = false }, 2000)
        }
    }
    return Promise.reject(error)
})

const request = {
    get: function (url, params, header = {}) {
        return http.get(url, {
            params: params
        }, header)
    },
    getAsync: async function (url, params, header = {}) {
        return await http.get(url, {
            params: params
        }, header).then((r) => {
            return r.data
        }).catch((r) => {
            return r.response.data
        })
    },
    post: function (url, params, header = {}) {
        return http.post(url, params, header)
    },
    postAsync: async function (url, params, header = {}) {
        return await http.post(url, params, header).then((r) => {
            return r.data
        }).catch((r) => {
            return r.response.data
        })
    },
    put: function (url, params, header = {}) {
        return http.put(url, params, header)
    },
    del: function (url, params, header = {}) {
        return http.delete(url, params, header)
    },
    download: function (url, params, filename) {
        http.get(url, {
            params: params,
            responseType: "blob"
        }).then(r => {
            const url = window.URL.createObjectURL(new Blob([r.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }))
            const a = document.createElement('a')
            a.style.display = "none"
            a.href = url
            a.setAttribute('download', filename)
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        })
    }
}

export default request
